let api_host = `/v1`;
const ExternalApi = `/api`;

export { api_host };

export default {
  // user
  login: `${api_host}/user/login`,
  login_sms_challenge: `${api_host}/user/login/sms-challenge`,
  first_password_change: `${api_host}/user/first-password-change`,
  reauthenticate: `${api_host}/user/reauthenticate`,
  reauthenticate_sms_challenge: `${api_host}/user/reauthenticate/sms-challenge`,
  security_status: `${api_host}/user/security-status`,
  phone_challenge: `${api_host}/user/phone/challenge`,
  phone_verify: `${api_host}/user/phone/verify`,
  logout: `${api_host}/user/logout`,
  register: `${api_host}/user/register`,
  setting: `${api_host}/user/setting`,
  user_info: `${api_host}/user/info`,
  tenant_info: `${api_host}/user/tenant_info`,
  set_tenant_info: `${api_host}/user/set_tenant_info`,
  login_channels: `${api_host}/user/login/channels`,
  login_channel: (channel: string) => `${api_host}/user/login/${channel}`,

  // platform account administration
  platform_accounts: `${api_host}/platform/accounts`,
  platform_account: (userId: string) =>
    `${api_host}/platform/accounts/${userId}`,
  reset_platform_account_password: (userId: string) =>
    `${api_host}/platform/accounts/${userId}/password/reset`,
  disable_platform_account: (userId: string) =>
    `${api_host}/platform/accounts/${userId}/disable`,
  restore_platform_account: (userId: string) =>
    `${api_host}/platform/accounts/${userId}/restore`,
  platform_account_memberships: (userId: string) =>
    `${api_host}/platform/accounts/${userId}/memberships`,
  platform_tenants: `${api_host}/platform/tenants`,
  platform_organization_units: `${api_host}/platform/organization-units`,

  // enterprise organization and knowledge authorization
  org_units: `${api_host}/org/units`,
  org_unit: (unitId: string) => `${api_host}/org/units/${unitId}`,
  move_org_unit: (unitId: string) => `${api_host}/org/units/${unitId}/move`,
  org_users: `${api_host}/org/users`,
  org_user_governance_profile: (userId: string) =>
    `${api_host}/org/users/${userId}/governance-profile`,
  org_user_memberships: (userId: string) =>
    `${api_host}/org/users/${userId}/memberships`,
  org_user_clearance: (userId: string) =>
    `${api_host}/org/users/${userId}/clearance`,
  org_groups: `${api_host}/org/groups`,
  org_group: (groupId: string) => `${api_host}/org/groups/${groupId}`,
  org_group_members: (groupId: string) =>
    `${api_host}/org/groups/${groupId}/members`,
  org_role_bindings: `${api_host}/org/role-bindings`,
  knowledge_resources: `${api_host}/knowledge/resources`,
  knowledge_resource_policy: (resourceId: string) =>
    `${api_host}/knowledge/resources/${resourceId}/policy`,
  agent_policy_context: (agentId: string) =>
    `${api_host}/knowledge/agents/${agentId}/policy-context`,
  knowledge_effective_access: (resourceId: string) =>
    `${api_host}/knowledge/resources/${resourceId}/effective-access`,
  knowledge_access_requests: `${api_host}/knowledge/access-requests`,
  my_knowledge_access_requests: `${api_host}/knowledge/access-requests/mine`,
  knowledge_requestable_resources: `${api_host}/knowledge/requestable-resources`,
  review_knowledge_access_request: (requestId: string, action: string) =>
    `${api_host}/knowledge/access-requests/${requestId}/review/${action}`,
  withdraw_knowledge_access_request: (requestId: string) =>
    `${api_host}/knowledge/access-requests/${requestId}/withdraw`,
  revoke_knowledge_access_request: (requestId: string) =>
    `${api_host}/knowledge/access-requests/${requestId}/revoke`,
  knowledge_policy_change_requests: `${api_host}/knowledge/policy-change-requests`,
  review_knowledge_policy_change_request: (requestId: string, action: string) =>
    `${api_host}/knowledge/policy-change-requests/${requestId}/${action}`,
  knowledge_publish_requests: `${api_host}/knowledge/publish-requests`,
  review_knowledge_publish_request: (requestId: string, action: string) =>
    `${api_host}/knowledge/publish-requests/${requestId}/${action}`,
  transfer_personal_space: (sourceUserId: string) =>
    `${api_host}/knowledge/personal-spaces/${sourceUserId}/transfer`,
  authorization_simulate: `${api_host}/authorization/simulate`,

  // team
  addTenantUser: (tenantId: string) => `${api_host}/tenant/${tenantId}/user`,
  listTenantUser: (tenantId: string) =>
    `${api_host}/tenant/${tenantId}/user/list`,
  deleteTenantUser: (tenantId: string, userId: string) =>
    `${api_host}/tenant/${tenantId}/user/${userId}`,
  listTenant: `${api_host}/tenant/list`,
  agreeTenant: (tenantId: string) => `${api_host}/tenant/agree/${tenantId}`,

  // llm model
  factories_list: `${api_host}/llm/factories`,
  llm_list: `${api_host}/llm/list`,
  my_llm: `${api_host}/llm/my_llms`,
  set_api_key: `${api_host}/llm/set_api_key`,
  add_llm: `${api_host}/llm/add_llm`,
  delete_llm: `${api_host}/llm/delete_llm`,
  deleteFactory: `${api_host}/llm/delete_factory`,
  model_references: `${api_host}/llm/references`,
  test_llm_connection: `${api_host}/llm/test_connection`,
  update_llm_api_base: `${api_host}/llm/update_api_base`,
  set_llm_enabled: `${api_host}/llm/set_enabled`,
  batch_set_llm_enabled: `${api_host}/llm/batch_set_enabled`,

  // plugin
  llm_tools: `${api_host}/plugin/llm_tools`,

  // knowledge base
  kb_list: `${api_host}/kb/list`,
  create_kb: `${api_host}/kb/create`,
  update_kb: `${api_host}/kb/update`,
  rm_kb: `${api_host}/kb/rm`,
  get_kb_detail: `${api_host}/kb/detail`,
  getKnowledgeGraph: (knowledgeId: string) =>
    `${api_host}/kb/${knowledgeId}/knowledge_graph`,
  getMeta: `${api_host}/kb/get_meta`,

  // tags
  listTag: (knowledgeId: string) => `${api_host}/kb/${knowledgeId}/tags`,
  listTagByKnowledgeIds: `${api_host}/kb/tags`,
  removeTag: (knowledgeId: string) => `${api_host}/kb/${knowledgeId}/rm_tags`,
  renameTag: (knowledgeId: string) =>
    `${api_host}/kb/${knowledgeId}/rename_tag`,

  // chunk
  chunk_list: `${api_host}/chunk/list`,
  create_chunk: `${api_host}/chunk/create`,
  set_chunk: `${api_host}/chunk/set`,
  get_chunk: `${api_host}/chunk/get`,
  switch_chunk: `${api_host}/chunk/switch`,
  rm_chunk: `${api_host}/chunk/rm`,
  retrieval_test: `${api_host}/chunk/retrieval_test`,
  knowledge_graph: `${api_host}/chunk/knowledge_graph`,

  // document
  get_document_list: `${api_host}/document/list`,
  document_change_status: `${api_host}/document/change_status`,
  document_rm: `${api_host}/document/rm`,
  document_delete: `${api_host}/api/document`,
  document_rename: `${api_host}/document/rename`,
  document_create: `${api_host}/document/create`,
  document_run: `${api_host}/document/run`,
  document_change_parser: `${api_host}/document/change_parser`,
  document_thumbnails: `${api_host}/document/thumbnails`,
  get_document_file: `${api_host}/document/download`,
  document_upload: `${api_host}/document/upload`,
  web_crawl: `${api_host}/document/web_crawl`,
  document_infos: `${api_host}/document/infos`,
  upload_and_parse: `${api_host}/document/upload_and_parse`,
  parse: `${api_host}/document/parse`,
  setMeta: `${api_host}/document/set_meta`,
  get_dataset_filter: `${api_host}/document/filter`,

  // chat
  setDialog: `${api_host}/dialog/set`,
  getDialog: `${api_host}/dialog/get`,
  removeDialog: `${api_host}/dialog/rm`,
  listDialog: `${api_host}/dialog/list`,
  setConversation: `${api_host}/conversation/set`,
  getConversation: `${api_host}/conversation/get`,
  getConversationSSE: `${api_host}/conversation/getsse`,
  listConversation: `${api_host}/conversation/list`,
  removeConversation: `${api_host}/conversation/rm`,
  cancelConversation: `${api_host}/conversation/cancel`,
  completeConversation: `${api_host}/conversation/completion`,
  deleteMessage: `${api_host}/conversation/delete_msg`,
  thumbup: `${api_host}/conversation/thumbup`,
  tts: `${api_host}/conversation/tts`,
  ask: `${api_host}/conversation/ask`,
  mindmap: `${api_host}/conversation/mindmap`,
  getRelatedQuestions: `${api_host}/conversation/related_questions`,
  // chat for external
  createToken: `${api_host}/api/new_token`,
  listToken: `${api_host}/api/token_list`,
  removeToken: `${api_host}/api/rm`,
  getStats: `${api_host}/api/stats`,
  createExternalConversation: `${api_host}/api/new_conversation`,
  getExternalConversation: `${api_host}/api/conversation`,
  completeExternalConversation: `${api_host}/api/completion`,
  uploadAndParseExternal: `${api_host}/api/document/upload_and_parse`,
  externalThumbup: `${api_host}/api/thumbup`,

  // next chat
  listNextDialog: `${api_host}/dialog/next`,
  chatWorkspaceBootstrap: `${api_host}/chat_workspace/bootstrap`,
  chatWorkspaceWebSearchConfig: `${api_host}/chat_workspace/web-search/config`,
  chatWorkspaceWebSearchProviders: `${api_host}/chat_workspace/web-search/providers`,
  chatWorkspaceWebSearchTest: `${api_host}/chat_workspace/web-search/test`,
  createChatSkill: `${api_host}/chat_workspace/skills`,
  importChatSkill: `${api_host}/chat_workspace/skills/import`,
  updateChatSkill: (id: string) => `${api_host}/chat_workspace/skills/${id}`,
  publishChatSkill: (id: string) =>
    `${api_host}/chat_workspace/skills/${id}/publish`,
  testChatSkill: (id: string) => `${api_host}/chat_workspace/skills/${id}/test`,
  listChatSkillVersions: (id: string) =>
    `${api_host}/chat_workspace/skills/${id}/versions`,
  exportChatSkill: (id: string) =>
    `${api_host}/chat_workspace/skills/${id}/export`,
  deleteChatSkill: (id: string) => `${api_host}/chat_workspace/skills/${id}`,
  listChatArtifacts: `${api_host}/chat_workspace/artifacts`,
  downloadChatArtifact: (id: string) =>
    `${api_host}/chat_workspace/artifacts/${id}/download`,

  imageGenerationCapabilities: `${api_host}/image_generation/capabilities`,
  imageGenerationJobs: `${api_host}/image_generation/jobs`,
  imageGenerationJob: (id: string) => `${api_host}/image_generation/jobs/${id}`,
  cancelImageGenerationJob: (id: string) =>
    `${api_host}/image_generation/jobs/${id}/cancel`,
  imageGenerationAssetContent: (id: string) =>
    `${api_host}/image_generation/assets/${id}/content`,
  imageGenerationAssetDownload: (id: string) =>
    `${api_host}/image_generation/assets/${id}/download`,

  // file manager
  listFile: `${api_host}/file/list`,
  uploadFile: `${api_host}/file/upload`,
  removeFile: `${api_host}/file/rm`,
  renameFile: `${api_host}/file/rename`,
  getAllParentFolder: `${api_host}/file/all_parent_folder`,
  createFolder: `${api_host}/file/create`,
  connectFileToKnowledge: `${api_host}/file2document/convert`,
  getFile: `${api_host}/file/get`,
  moveFile: `${api_host}/file/mv`,

  // system
  getSystemVersion: `${api_host}/system/version`,
  getSystemStatus: `${api_host}/system/status`,
  getEnrichmentStatus: `${api_host}/system/enrichment/status`,
  getEnrichmentConfig: `${api_host}/system/enrichment/config`,
  updateEnrichmentConfig: `${api_host}/system/enrichment/config`,
  controlEnrichment: `${api_host}/system/enrichment/control`,
  taskConsoleSummary: `${api_host}/task_console/summary`,
  taskConsoleTasks: `${api_host}/task_console/tasks`,
  taskConsoleTask: (id: string) => `${api_host}/task_console/tasks/${id}`,
  cancelTaskConsoleTask: (id: string) =>
    `${api_host}/task_console/tasks/${id}/cancel`,
  retryTaskConsoleTask: (id: string) =>
    `${api_host}/task_console/tasks/${id}/retry`,
  dataSourceCatalog: `${api_host}/data_source/catalog`,
  dataSourceList: `${api_host}/data_source/list`,
  createDataSource: `${api_host}/data_source/create`,
  testDataSourceDraft: `${api_host}/data_source/test`,
  dataSource: (id: string) => `${api_host}/data_source/${id}`,
  testDataSource: (id: string) => `${api_host}/data_source/${id}/test`,
  browseDataSource: (id: string) => `${api_host}/data_source/${id}/browse`,
  syncDataSource: (id: string) => `${api_host}/data_source/${id}/sync`,
  dataSourceRuns: (id: string) => `${api_host}/data_source/${id}/runs`,
  getSystemTokenList: `${api_host}/system/token_list`,
  createSystemToken: `${api_host}/system/new_token`,
  publishAgent: `${api_host}/system/published-agents`,
  getPublishedAgentStatus: `${api_host}/system/published-agents`,
  revokePublishedAgent: `${api_host}/system/published-agents`,
  listSystemToken: `${api_host}/system/token_list`,
  removeSystemToken: `${api_host}/system/token`,
  getSystemConfig: `${api_host}/system/config`,
  updateSystemWebsiteConfig: `${api_host}/system/website_config`,
  getSystemSmsConfig: `${api_host}/system/sms_config`,
  updateSystemSmsConfig: `${api_host}/system/sms_config`,
  testSystemSmsConfig: `${api_host}/system/sms_config/test`,
  setSystemSmsEnabled: `${api_host}/system/sms_config/enabled`,
  setLangfuseConfig: `${api_host}/langfuse/api_key`,

  operation_logs: api_host + '/operation-logs',

  chunk_revisions: `${api_host}/chunk/revisions`,
  revert_chunk_revision: `${api_host}/chunk/revert`,

  // flow
  listTemplates: `${api_host}/canvas/templates`,
  listCanvas: `${api_host}/canvas/list`,
  listCanvasTeam: `${api_host}/canvas/listteam`,
  getCanvas: `${api_host}/canvas/get`,
  getCanvasSSE: `${api_host}/canvas/getsse`,
  removeCanvas: `${api_host}/canvas/rm`,
  setCanvas: `${api_host}/canvas/set`,
  settingCanvas: `${api_host}/canvas/setting`,
  getListVersion: `${api_host}/canvas/getlistversion`,
  getVersion: `${api_host}/canvas/getversion`,
  resetCanvas: `${api_host}/canvas/reset`,
  runCanvas: `${api_host}/canvas/completion`,
  testDbConnect: `${api_host}/canvas/test_db_connect`,
  getInputElements: `${api_host}/canvas/input_elements`,
  debug: `${api_host}/canvas/debug`,
  uploadCanvasFile: `${api_host}/canvas/upload`,
  trace: `${api_host}/canvas/trace`,
  // agent
  inputForm: `${api_host}/canvas/input_form`,
  fetchVersionList: (id: string) => `${api_host}/canvas/getlistversion/${id}`,
  fetchVersion: (id: string) => `${api_host}/canvas/getversion/${id}`,
  fetchCanvas: (id: string) => `${api_host}/canvas/get/${id}`,
  fetchAgentAvatar: (id: string) => `${api_host}/canvas/getsse/${id}`,
  uploadAgentFile: (id?: string) => `${api_host}/canvas/upload/${id}`,
  fetchAgentLogs: (canvasId: string) =>
    `${api_host}/canvas/${canvasId}/sessions`,
  fetchExternalAgentInputs: (canvasId: string) =>
    `${ExternalApi}${api_host}/agentbots/${canvasId}/inputs`,

  // mcp server
  listMcpServer: `${api_host}/mcp_server/list`,
  getMcpServer: `${api_host}/mcp_server/detail`,
  createMcpServer: `${api_host}/mcp_server/create`,
  updateMcpServer: `${api_host}/mcp_server/update`,
  deleteMcpServer: `${api_host}/mcp_server/rm`,
  importMcpServer: `${api_host}/mcp_server/import`,
  exportMcpServer: `${api_host}/mcp_server/export`,
  listMcpServerTools: `${api_host}/mcp_server/list_tools`,
  testMcpServerTool: `${api_host}/mcp_server/test_tool`,
  cacheMcpServerTool: `${api_host}/mcp_server/cache_tools`,
  testMcpServer: `${api_host}/mcp_server/test_mcp`,

  // next-search
  createSearch: `${api_host}/search/create`,
  getSearchList: `${api_host}/search/list`,
  deleteSearch: `${api_host}/search/rm`,
  getSearchDetail: `${api_host}/search/detail`,
  updateSearchSetting: `${api_host}/search/update`,
};
